export default __webpack_public_path__ + "static/media/gallery_11.9428bb9e.jpg";